import React from 'react'

import styles from './UnblockerManualBlock.module.scss'

import HelpLink from 'components/elements/other/HelpLink'
import { THelpLink } from '../../../../elements/other/HelpLink/HelpLink'

import { UnblockerManualLinks } from 'utils/unblocker/unblockerConstants'

interface IUnblockerManualBlock {
  className?: string
}

const UnblockerManualBlock: React.FC<IUnblockerManualBlock> = (props) => {
  const manualBlockList = UnblockerManualLinks.map(
    (block: { title: string; items: THelpLink[] }, index: number) => {
      return (
        <div className={styles.block} key={`manual_block-${block.title}-${index}`}>
          <div className={styles.blockTitle}>
            {block.title}
          </div>
          <div className={styles.blockContent}>
            {block.items.map((blockItem: THelpLink, index: number) => (
              <HelpLink
                link={blockItem}
                className={styles.blockItem}
                key={`manual_block_item-${block.title}-${index}`}
              />
            ))}
          </div>
        </div>
      )
    }
  )

  return (
    <div className={props.className || ''}>
      {manualBlockList}
    </div>
  )
}

export default UnblockerManualBlock
